import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { JwtHelper } from 'angular2-jwt';

import { AppComponent } from '../app.component';
import { LoginService } from './login.service';

declare var $:any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService, JwtHelper]
})

export class LoginComponent implements OnInit {

   form = {
      login:'',
      password:'',
      remember: false
   }

   static rememberMe:boolean = false;

   errorMessage:string = '';
   warningMessage:string = '';

  constructor(private loginService:LoginService, private router:Router, private jwt:JwtHelper) {
    if (AppComponent.token != '' && AppComponent.rememberMe){
      this.router.navigate(['/admin']);
    } else {
      AppComponent.logout();
    }
  }

  ngOnInit() {
    var _this = this;

    $('#remember').iCheck({
      checkboxClass: 'icheckbox_square-blue',
      radioClass: 'icheckbox_square-blue'
    });

    $('input').on('ifChecked', function(event){
      LoginComponent.rememberMe = true;
      if ($("body").hasClass('private-browser')){
        _this.warningMessage = 'The "remember me" function does not work in private mode.';
      }
    });

    $('input').on('ifUnchecked', function(event){
      LoginComponent.rememberMe = false;
      if ($("body").hasClass('private-browser')){
        _this.warningMessage = '';
      }
    });

  }

  onSubmit(){

     if (this.form.login == ''){
       this.errorMessage = 'Complete all fields';
        return;
     }

     if (this.form.password == ''){
       this.errorMessage = 'Complete all fields';
        return;
     }

    //  this.errorMessage = 'Antes do post';
     this.loginService.getToken(this.form.login, this.form.password).subscribe(
        res => this.loginSuccess(res),
        error => this.loginError(error),
        () => console.log('Login Finished')
     );
  }

  private loginSuccess(token:any){
    //  this.errorMessage = JSON.stringify(token);

     AppComponent.token = token
     AppComponent.rememberMe = LoginComponent.rememberMe;
     AppComponent.user = this.jwt.decodeToken(token.access_token);

    //  this.errorMessage = JSON.stringify(token);

     this.router.navigate(['/admin']);
  }

  private loginError(response:any){
    let body = JSON.parse(response._body);
    this.errorMessage = body.error_description;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts